module.exports = __webpack_public_path__ + "static/media/error.d8faadc3.svg";